// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1XOaE","right":"Footer_right__2m90K","buttons":"Footer_buttons__cVRTf"};